import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, Transition as _Transition, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, nextTick } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TransitionSlide',
  props: {
  direction: {
    type: String,
    default: "vertical",
  },
  duration: {
    type: Number,
    default: 400,
  },
},
  setup(__props) {

const props = __props



const widthOrHeight = computed(() =>
  props.direction === "vertical" ? "height" : "width"
);

function beforeEnter(el: HTMLElement) {
  el.style[widthOrHeight.value] = "0";
  el.style.transitionDuration = `${props.duration}ms`;
  el.style.transitionProperty = widthOrHeight.value;

  nextTick(() => {
    if (widthOrHeight.value === "height") {
      el.style.height = `${el.scrollHeight}px`;
    } else {
      el.style.width = `${el.scrollWidth}px`;
    }
  });
}

function afterEnter(el: HTMLElement) {
  el.style[widthOrHeight.value] = "";
  el.style.transitionDuration = "";
  el.style.transitionProperty = "";
}

function beforeLeave(el: HTMLElement) {
  if (widthOrHeight.value === "height") {
    el.style.height = `${el.scrollHeight}px`;
  } else {
    el.style.width = `${el.scrollWidth}px`;
  }

  el.style.transitionDuration = `${props.duration}ms`;
  el.style.transitionProperty = widthOrHeight.value;

  setTimeout(() => {
    el.style[widthOrHeight.value] = "0";
  }, 50);
}

function afterLeave(el: HTMLElement) {
  el.style[widthOrHeight.value] = "";
  el.style.transitionDuration = "";
  el.style.transitionProperty = "";
}

const hooks = computed(() => {
  return {
    beforeEnter,
    afterEnter,
    beforeLeave,
    afterLeave,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, _mergeProps({ name: "slide" }, _ctx.$attrs, _toHandlers(_unref(hooks))), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})